import React from "react";
import { MapPin, ExternalLink, Plus, Minus, Maximize } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ServiceCoverageArea() {
  return <section data-section-id="62357" id="auckland-hq" className="bg-background text-foreground relative w-full h-[500px] md:h-[600px] overflow-hidden border-y border-border">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1595871/img/map_dark_auckland.png)] grayscale-[15%] contrast-110 brightness-100" aria-label="Map showing Projectora office location in Auckland" />

      {}
      <div className="absolute inset-0 bg-primary/5 pointer-events-none" />

      {}
      <div className="absolute top-6 left-6 z-10">
        <Button asChild variant="secondary" className="bg-card/90 backdrop-blur-xl border border-border/50 text-card-foreground hover:bg-card shadow-2xl transition-all duration-500 rounded-sm h-12 px-6 gap-3">
          <Link to="https://www.google.com/search?q=8/133+Bayswater+Avenue,+Bayswater,+Auckland+0622&shndl=40&source=sh/x/loc/geo/m1/1&kgs=1ab3577f52ed62a7&shem=shrtsdl&utm_source=shrtsdl,sh/x/loc/geo/m1/1" newTab aria-label="Get directions and parking info for Projectora Auckland">
            <MapPin className="w-5 h-5 text-chart-2" />
            <span className="font-bold tracking-tight uppercase text-xs">Directions & Parking</span>
            <ExternalLink className="w-4 h-4 opacity-50 ml-1" />
          </Link>
        </Button>
      </div>

      {}
      <div className="absolute bottom-6 right-6 z-10 flex flex-col gap-3">
        {}
        <div className="flex flex-col bg-card/90 backdrop-blur-xl border border-border/50 rounded-sm shadow-2xl overflow-hidden">
          <Button variant="ghost" size="icon" className="h-10 w-10 rounded-none border-b border-border/50 hover:bg-accent/50 active:bg-accent text-foreground" aria-label="Zoom in">
            <Plus className="w-5 h-5" />
          </Button>
          <Button variant="ghost" size="icon" className="h-10 w-10 rounded-none hover:bg-accent/50 active:bg-accent text-foreground" aria-label="Zoom out">
            <Minus className="w-5 h-5" />
          </Button>
        </div>

        {}
        <Button variant="secondary" size="icon" className="h-10 w-10 bg-card/90 backdrop-blur-xl border border-border/50 rounded-sm shadow-2xl hover:bg-accent/50 active:bg-accent text-foreground" aria-label="Toggle fullscreen view">
          <Maximize className="w-5 h-5" />
        </Button>
      </div>

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none drop-shadow-2xl">
        <MapPin className="w-14 h-14 text-chart-2 fill-chart-2/10 animate-bounce" />
      </div>
    </section>;
}